import { User } from './user'
import { BaseModel, BelongsTo, Attribute } from './base-model'

export class Area extends BaseModel {
  public id       : number
  @Attribute(Date)   public createdAt: Date
  public position : number
  @BelongsTo(User)   public user     : User
  public sessionId: string

  public originX: number
  public originY: number
  public width: number
  public height: number
}



// WEBPACK FOOTER //
// ./src/models/area.ts